import BaseObject from '../../../../base/base_object';
import {KEY_NAME} from "../../native/native_const";
import _ from "../../../../utils/underscore";
import Event from "../../../../utils/event";
import {SYSTEM_EVENTS} from "../../../../events/events";
import {TokenType} from "../../../../../../common/const/token_type";


const BUSINESS_COR_ID = 'af_sub5';


class HybridMigration extends BaseObject {
    /**
     * @static
     * @type {string}
     */
    static CLASS = 'HybridMigration';

    _HybridService = null;
    _migrationToken='';
    _businessCorrId='';
    _bRunAutoLoginOnlyOnce=false;

    init(params) {
        super.init();
    }


    initFeatures(hybridSrv) {

        this._HybridService = hybridSrv;

        this._getHybridToken();

        this._subscribe();
    }

    _subscribe() {
        Event.on(SYSTEM_EVENTS.APPS_FLAYER_READY, this._onAppsFlayerReady, this);
        Event.on(SYSTEM_EVENTS.DEEP_LINK_READY, this._onDeepLinkReady, this);
    }


    _onAppsFlayerReady(dataObj){

        this._businessCorrId = dataObj[BUSINESS_COR_ID];
        this._runAutoLoginWhenDataIsReady(true);
    }

    _onDeepLinkReady(dataObj){

        let obj = new URLSearchParams(dataObj[KEY_NAME.DATA]);
        this._businessCorrId = obj.get(BUSINESS_COR_ID);
        this._runAutoLoginWhenDataIsReady(false);
        this._getHybridToken();
    }


    _getHybridToken() {
        const dt = {[KEY_NAME.DELETE]: 'true'};
        this._HybridService.getMigrationToken(dt).then(data => {
            this._migrationToken = this._extractToken(data);
            this._runAutoLoginWhenDataIsReady(false);
        });
    }

    _extractToken(data){
        const json = _.safeJSONandDecode(data);
        const datatoken = json[KEY_NAME.DATA];
        return datatoken[KEY_NAME.TOKEN];
    }

    _runAutoLoginWhenDataIsReady(bIgnoreBusinessCorrId){

        if (!this._bRunAutoLoginOnlyOnce && this._migrationToken && this._migrationToken.toString().length > 0 && (bIgnoreBusinessCorrId || !_.isEmpty(this._businessCorrId))) {
            this._bRunAutoLoginOnlyOnce = true;

            if(_.isEmpty(this._businessCorrId) || !_.isGuid(this._businessCorrId)){
                this._businessCorrId = _.getGuid();
            }

            this._HybridService.serviceFactory.oAuth2Service().runAutoLogin(this._migrationToken, null, null, null, null, null, TokenType.MigrationToken, this._businessCorrId);

            this._HybridService.serviceFactory.playerMigrationProxyService().sendClientVisitAnalytics({
                businessCorrelationId: this._businessCorrId,
                migrationToken: this._migrationToken
            });
        }
    }
}

export default HybridMigration;
